import { useEffect } from "react";
import { WSQueryCache } from "@ws-react-query";

import { WSProgressBar } from "@wingspanhq/fe-component-library";

import { getBulkQueriesByResource } from "../../query/bulkBatchResourceQueryMap";
import {
  QUERY_BULK_COLLABORATOR_BATCH,
  QUERY_BULK_COLLABORATOR_BATCH_SUMMARY
} from "../../query/bulkCollaborator/keys";
import { BulkResource } from "../../types";
import { useFlatfileUploadJobStatus } from "../../hooks/useFlatfileUploadJobStatus";

interface BulkBatchUploadProgressProps {
  bulkBatchId: string;
  bulkResource: BulkResource;
}

/**
 * This component is responsible for displaying the progress of a batch upload
 * in Flatfile platform while creating import items in the Bulk Importer.
 */
export const BulkBatchUploadProgress: React.FC<
  BulkBatchUploadProgressProps
> = ({ bulkBatchId, bulkResource }) => {
  const { useBulkBatch, useBulkBatchSummary } =
    getBulkQueriesByResource(bulkResource);
  const qBulkBatch = useBulkBatch(bulkBatchId);

  // to update the collaborators count on details page
  useBulkBatchSummary(
    bulkBatchId,
    {},
    {
      refetchInterval: 2000
    }
  );

  const { progress } = useFlatfileUploadJobStatus(qBulkBatch.data);

  useEffect(() => {
    return () => {
      // As uploading is done, invalidate the queries to refetch the updated data
      WSQueryCache.invalidateQueries([
        QUERY_BULK_COLLABORATOR_BATCH,
        bulkBatchId
      ]);
      WSQueryCache.invalidateQueries(QUERY_BULK_COLLABORATOR_BATCH_SUMMARY);
    };
  }, [bulkBatchId]);

  return <WSProgressBar percent={progress} text={null} />;
};
